import { Logger } from "../../logger";

// Helper to call delete on Emscripten objects (not in type definitions)

export function deleteObj(obj: any): void {
  if (!obj) return;
  // Emscripten sets $$deleted = true after obj.delete() — detect double-free
  if (obj.$$deleted) {
    Logger.captureException(new Error("ODA double-free"), {
      constructorName: obj.constructor?.name ?? "unknown",
    });
    return;
  }
  if (typeof obj.delete === "function") {
    obj.delete();
  }
}
